import {LIBRARY_CONVERSATIONS_ID} from '@reados/contracts';
import type {LibraryEntry} from './library';

export type RenameLibraryEntry=LibraryEntry;

export function canRenameLibraryEntry(entry:LibraryEntry):entry is RenameLibraryEntry {
  return entry.kind==='thread'||entry.kind==='file'||(entry.kind==='folder'&&entry.id!==LIBRARY_CONVERSATIONS_ID&&!entry.folder.system);
}

export const normalizedLibraryName=(name:string)=>name.trim().normalize('NFC');
export const normalizedRenameName=(kind:LibraryEntry['kind'],name:string)=>kind==='thread'?name.trim():normalizedLibraryName(name);

/** Conversation titles are metadata, so path punctuation and Unicode spelling remain intact. */
export function threadRenameIssue(title:string):string {
  if(/[\u0000-\u001f\u007f-\u009f]/u.test(title))return '对话名称不能包含控制字符。';
  const value=title.trim();
  if(!value)return '请输入对话名称。';
  if(Array.from(value).length>200)return '对话名称不能超过 200 个字符。';
  return '';
}
export const renameEntryIssue=(kind:LibraryEntry['kind'],name:string)=>kind==='thread'?threadRenameIssue(name):libraryRenameIssue(name);

/** Match the canonical filesystem name boundary, including non-ASCII byte length. */
export function libraryRenameIssue(name:string):string {
  const value=normalizedLibraryName(name);
  if(!value)return '请输入名称。';
  if(new TextEncoder().encode(value).length>240)return '名称过长，请缩短后重试。';
  if(value==='.'||value==='..'||value.startsWith('.reados-'))return '请使用其他名称。';
  if(/[\\/\u0000-\u001f\u007f]/u.test(value))return '名称不能包含斜杠或控制字符。';
  return '';
}

/** Select the basename so typing a new file name leaves its extension intact. */
export function libraryRenameSelection(entry:Pick<RenameLibraryEntry,'kind'|'name'>):[number,number] {
  const dot=entry.name.lastIndexOf('.');
  return [0,entry.kind==='file'&&dot>0&&dot<entry.name.length-1?dot:entry.name.length];
}
